import React from "react";

export const DiamondDivider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-2 ${className}`} aria-hidden="true">
    <span className="block h-px w-10 bg-aa-gold/40" />
    <span className="diamond opacity-90" />
    <span className="diamond opacity-60" />
    <span className="diamond opacity-90" />
    <span className="block h-px w-10 bg-aa-gold/40" />
  </div>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`font-body text-xs sm:text-sm uppercase tracking-[0.28em] text-aa-gold ${className}`}>
    {children}
  </span>
);
